import React from 'react'
import { isArray } from 'lodash-es'
import createContext from 'zustand/context'
import create from 'zustand'
import shallow from 'zustand/shallow'

// import { getQuery } from '@vt/utils'

// import { useViewConfigSWR } from '../../swrs/tables/use-view-config-swr'
import createTbViewStore from './create-tbview-mul-store'
import { useAppStore } from '../../apps/app-store-provider'

const { Provider, useStore } = createContext()

// export const useTbViewStore = useStore
export const useTbViewMulStore = (selectors, equalityFn = shallow) => {
  if (isArray(selectors)) {
    const selectedVals = {}
    for (let index = 0; index < selectors.length; index++) {
      const element = selectors[index]
      selectedVals[element] = useStore((x) => x[element], equalityFn)
    }
    return selectedVals
  }
  return useStore(selectors, equalityFn)
}

export const TbViewMulProvider = ({ children, tbs, extendsStore }) => {
  // const appId = useAppStore((x) => x.appId)
  const getDitto = useAppStore((x) => x.getDitto)
  // const [initedStore, setInitedStore] = useState()

  // // 判断是否是回收站
  // const { type, isRecycle } = getQuery()
  // const dittos = {}

  tbs.forEach((tb) => {
    tb.ditto = getDitto(tb.tbId)
  })
  // const { viewConfig } = useViewConfigSWR(appId, ditto.tbId || tbId, vid, {
  //   isRecycle: isRecycle || type === 'recycle',
  // })

  // useEffect(() => {
  //   if (viewConfig) {
  //     setInitedStore(false)
  //     setTimeout(() => {
  //       setInitedStore(true)
  //     }, 10)
  //   }
  // }, [viewConfig])

  // if (!initedStore) {
  //   return null
  // }

  // console.log('[1]', viewConfig)
  // const createStore = () => create(setInitedStore)
  const createStore = () => create(createTbViewStore(tbs, extendsStore))
  return <Provider createStore={createStore}>{children}</Provider>
}
